// Single source of truth for the widget's supported locales.
// Base language codes only — regional variants (en-US, es-MX, pt-BR, ...)
// are collapsed by normalizeLocale before lookup. Every entry must have a
// matching catalog in ../messages/<code>.json.
export const defaultLocale = 'en'

export const supportedLocales = [
  'ar', // Arabic
  'az', // Azerbaijani
  'de', // German
  'el', // Greek
  'en', // English
  'es', // Spanish
  'fa', // Persian
  'fi', // Finnish
  'fr', // French
  'gu', // Gujarati
  'hi', // Hindi
  'hy', // Armenian
  'id', // Indonesian
  'it', // Italian
  'ja', // Japanese
  'ka', // Georgian
  'kk', // Kazakh
  'kn', // Kannada
  'ko', // Korean
  'ku', // Kurdish (Sorani)
  'ky', // Kyrgyz
  'mr', // Marathi
  'ms', // Malay
  'pa', // Punjabi
  'pl', // Polish
  'pt', // Portuguese
  'ru', // Russian
  'ta', // Tamil
  'te', // Telugu
  'th', // Thai
  'tl', // Tagalog
  'tr', // Turkish
  'uk', // Ukrainian
  'ur', // Urdu
  'uz', // Uzbek
  'vi', // Vietnamese
  'zh' // Chinese (Simplified)
] as const

export type SupportedLocale = (typeof supportedLocales)[number]

export const localeAliases: Record<string, string> = {
  aze: 'az',
  ckb: 'ku',
  cmn: 'zh',
  ell: 'el',
  fas: 'fa',
  fil: 'tl',
  geo: 'ka',
  gre: 'el',
  hye: 'hy',
  in: 'id', // legacy ISO code for Indonesian
  ind: 'id',
  jpn: 'ja',
  kat: 'ka',
  kaz: 'kk',
  kir: 'ky',
  kor: 'ko',
  kur: 'ku',
  may: 'ms',
  msa: 'ms',
  per: 'fa',
  sorani: 'ku',
  tgl: 'tl',
  tha: 'th',
  ukr: 'uk',
  urd: 'ur',
  uzb: 'uz',
  vie: 'vi',
  zho: 'zh'
}

export const rtlLocales = ['ar', 'fa', 'ku', 'ur']

export function normalizeLocale(locale: string | undefined) {
  if (!locale) return defaultLocale

  const normalizedLocale = locale.trim().replace('_', '-').toLowerCase().split('-')[0]
  const aliasedLocale = localeAliases[normalizedLocale] || normalizedLocale

  return (supportedLocales as readonly string[]).includes(aliasedLocale) ? aliasedLocale : defaultLocale
}
